import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const pimListSelector = state => state.list;
const pimRootSelector = state => state;

const mapProductsImages = (images) => {
  if (!images) return [];
  return ([
    ...images.map((img) => {
      const params = '?auto=format%2Ccompress&bg=transparent&fill=solid&fit=fillmax&h=220&trim=auto&trimsd=1&w=auto';
      return {
        ...img,
        url: `${img.url}${params}`,
      };
    }),
  ]);
};

const listSelector = createSelector(
  pimListSelector,
  list => (!isEmpty(list) ? list.reduce((acc, current) => {
    acc.push({
      ...current,
      images: mapProductsImages(current.images),
      variants: !isEmpty(current.variants)
        ? current.variants.map(v => ({
          ...v,
          images: mapProductsImages(v.images),
          merchants: !isEmpty(v.merchants)
            ? v.merchants.map(m => ({
              ...m,
              images: mapProductsImages(m.images),
            }))
            : [],
        }))
        : [],
    });
    return acc;
  }, []) : []),
);

export const pimSelector = createSelector(
  listSelector,
  pimRootSelector,
  (list, state) => ({
    list,
    filterTarget: state.filterTarget,
    savedFilterFilters: state.savedFilterFilters,
    savedFilterFields: state.savedFilterFields,
    globalFields: state.globalFields,
    globalFilters: state.globalFilters,
    searchQuery: state.searchQuery,
    fullTextListModeSearch: state.fullTextListModeSearch,
    isCustomFieldsMode: state.isCustomFieldsMode,
    sort: state.sort,
    isEditMode: state.isEditMode,
    selected: state.selected,
    pagination: state.pagination,
    productsCommentsCount: state.productsCommentsCount,
    defaultImage: state.defaultImage,
    displayMode: state.displayMode,
    fetchParentLevelChildrenProductsStarted: state.fetchParentLevelChildrenProductsStarted,
    lastParentChildrenLoaded: state.lastParentChildrenLoaded,
    productsPhysicalCategoryList: state.productsPhysicalCategoryList,
    productsPhysicalCategoryListFetching: state.productsPhysicalCategoryListFetching,
    bulkDeleteProductLockedAttributesStarted: state.bulkDeleteProductLockedAttributesStarted,
    bulkDeleteProductLockedAttributesFinished: state.bulkDeleteProductLockedAttributesFinished,
  }),
);

export default {
  pimSelector,
};
